import { mustBeFilled } from '../../libs/validators';

export const inputIdentityProviderConfig = {
  label: 'Compte utilisé',
  name: 'identityProvider',
  validators: { format: [], submit: mustBeFilled('Veuillez sélectionner le compte utilisé') },
};
